import React from 'react';
import {useFormik} from 'formik'
import {Button, Input} from "antd";
import {ErrorMessageWidget} from "@/components/form/errorMessageWidget";
import {useApiCreateAdminPollSurvey} from "@/api/survey";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useNavigate} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import FreeBox from "@/components/box/freeBox";

function AdminSurveyCreatePage() {


    const navigate = useNavigate();
    const myBreadCrumb = [
        {
            path: URLS.homepage,
            title: "خانه"
        },
        {
            path: URLS.admin.survey.dashboard,
            title: "نظرسنجی"
        },
        {
            path: URLS.admin.survey.create,
            title: "ایجاد نظرسنجی جدید"
        }
    ]

    const {mutate: addSurvey, isPending} = useApiCreateAdminPollSurvey()

    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {

            addSurvey({...values},
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                        if (res?.data?.data?.id) {
                            navigate(sprintf(URLS.admin.survey.edit, {id: res?.data?.data?.id}))
                        }
                    },
                    onError: (res) => {
                        ApiHandleErrorMessage(res)
                    },
                })


        }
    })


    return (<>
            <AdminLayout pageTitle={'ایجاد نظر سنجی'} breadCrumb={myBreadCrumb}>
                <FreeBox>
                    <div>
                        <div className={`flex flex-col gap-1`}>
                            <span className={`font-medium`}>عنوان نظرسنجی </span>
                            <Input placeholder={"عنوان را وارد کنید"}
                                   value={formik.values.title}
                                   disabled={isPending}
                                   status={formik.errors.title && "error"}
                                   onChange={(e) => formik.setFieldValue("title", e.target.value)}
                                   onPressEnter={() => formik.submitForm()}
                            />
                            {formik.errors.title && <ErrorMessageWidget message={formik.errors.title}/>}
                        </div>

                        <div className={`mt-4 flex justify-end`}>
                            <Button onClick={formik.submitForm} type={'primary'} loading={isPending}>
                                {'ایجاد نظرسنجی'}
                            </Button>
                        </div>
                    </div>
                </FreeBox>

            </AdminLayout>
        </>
    )
}

export default AdminSurveyCreatePage;


